var Flickity = require('flickity');
var Flickity = require('flickity-bg-lazyload');

if(document.querySelector('.clientes2') != null) {
       // carrusel   
       let carrusel = document.querySelector('.testimonios_carrusel')
       var flkty = new Flickity( carrusel, {
         // options
         cellAlign: 'center',
         contain: true,
         autoPlay: 2500 
       });
}